import React, { useState } from 'react';
import { adminApi } from '../../api';


export default function UtilsPanel() {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [isSendingNewsletter, setIsSendingNewsletter] = useState(false);
  const [newsletterMessage, setNewsletterMessage] = useState('');
  const [newsletterError, setNewsletterError] = useState('');

  const handleSendNewsletterEmail = async () => {
    setNewsletterMessage('');
    setNewsletterError('');
    setIsSendingNewsletter(true);

    try {
      const payload = {};
      const recipientEmail = newsletterEmail.trim();
      if (recipientEmail) {
        payload.recipientEmail = recipientEmail;
      }

      const { data } = await adminApi.post('/admin/email/request_newsletter_test_email', payload);

      setNewsletterMessage(
        `Queued newsletter test email to ${data?.recipientEmail || recipientEmail || 'default admin email'}.`
      );
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        'Failed to queue newsletter test email.';
      setNewsletterError(message);
    } finally {
      setIsSendingNewsletter(false);
    }
  };

  return (
    <div className="text-left text-gray-100">
      <section className="max-w-2xl rounded-lg border border-gray-700 bg-gray-900/60 p-5">
        <div className="mb-4">
          <h3 className="text-lg font-semibold">Newsletter</h3>
          <p className="mt-1 text-sm text-gray-400">
            Send a weekly newsletter test email. Leave recipient blank to use the default admin email.
          </p>
        </div>

        <label htmlFor="newsletterEmail" className="mb-2 block text-sm font-medium text-gray-300">
          Test recipient email
        </label>
        <input
          id="newsletterEmail"
          type="email"
          value={newsletterEmail}
          onChange={(event) => setNewsletterEmail(event.target.value)}
          placeholder="roy@samsar.one"
          className="mb-4 w-full rounded border border-gray-600 bg-gray-900 px-3 py-2 text-gray-100 placeholder:text-gray-500 focus:border-blue-400 focus:outline-none"
        />

        <button
          type="button"
          onClick={handleSendNewsletterEmail}
          disabled={isSendingNewsletter}
          className="rounded bg-blue-500 px-4 py-2 font-semibold text-white transition-colors hover:bg-blue-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isSendingNewsletter ? 'Queueing...' : 'Send newsletter email'}
        </button>

        {newsletterMessage && (
          <p className="mt-4 rounded border border-green-600/60 bg-green-900/40 px-3 py-2 text-sm text-green-100">
            {newsletterMessage}
          </p>
        )}

        {newsletterError && (
          <p className="mt-4 rounded border border-red-600/60 bg-red-900/40 px-3 py-2 text-sm text-red-100">
            {newsletterError}
          </p>
        )}
      </section>
    </div>
  );
}
